import axios from 'axios'

import { apiUrl } from '@/config'

const state = {
  wishlist: null,
}

const getters = {}

const mutations = {
  setWishlist (state, wishlist) {
    state.wishlist = wishlist;
  },
}

const actions = {
  getWishlist(context, user) {
    if (user === null) { return context.commit('setWisthlist', null); }
    return axios.get(`${apiUrl}/api/wishlist/${user}`)
      .then(response => { context.commit('setWishlist', response.data) })
      .catch(e => { console.log(e) })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
